import http from "../../core/services/http.service";

const NotificationActivityService = {
  getNotificationActivities(params = null, expand = '') {
    return http.get(`/api/v1/activity/notification/?expand=${expand}`, {params});
  },
  getNotificationActivityPDF(notificationActivityUuid, attachmentName) {
    return http.get(`/api/v1/activity/notification/${notificationActivityUuid}/attachment-pdf/?attachment_name=${attachmentName}`);
  },
};

export default NotificationActivityService;
